import React from 'react'
import { Form } from 'antd'
import { Button, TextAreaField } from '@forwardflow/ui'
import { ICampaignQuestions } from '@forwardflow/types/organization'

interface QuestionFormProps {
   selectedQuestion?: ICampaignQuestions
   isLoading: boolean
   detailsCharCount: number
   form: any
   handleSubmit: () => void
   setDetailsCharCount: (count: number) => void
}

const QuestionSubmitForm: React.FC<QuestionFormProps> = ({
   selectedQuestion,
   isLoading,
   detailsCharCount,
   form,
   handleSubmit,
   setDetailsCharCount,
}) => {
   return (
      <div>
         <p className="text-white/70 text-[12px] font-medium mb-3 px-10 mt-3">
            {selectedQuestion ? 'Edit' : 'Add'} unique question
         </p>
         <div className="relative bg-black/40">
            <Form
               layout="vertical"
               form={form}
               initialValues={{}}
               onFinish={handleSubmit}
               className="w-full text-left text-white"
               autoComplete="off"
            >
               <div className="px-10">
                  <TextAreaField
                     name="question"
                     placeholder="Type a question or statement"
                     formItemClassName="w-full"
                     className="!border-none !bg-transparent !h-20 !shadow-none relative top-3 !pl-0"
                     isRequired
                     maxLength={200}
                     errorMessage="Please enter question"
                     onChange={(e) =>
                        setDetailsCharCount(e.target.value.length)
                     }
                  />
               </div>

               <div className="flex items-center justify-between p-3 pl-10">
                  <p className="text-[#B98BE6]">{detailsCharCount}/200 char</p>
                  <Button
                     isLoading={isLoading}
                     type="submit"
                     className="!h-10 !mt-0 max-w-[160px] !rounded !bg-primary/50 !border-none hover:!bg-primary/80"
                  >
                     {selectedQuestion ? 'Edit' : 'Add'} Question
                  </Button>
               </div>
            </Form>
         </div>
      </div>
   )
}

export default QuestionSubmitForm
